import { render } from "./MyApprovals.vue?vue&type=template&id=7f8b1855&scoped=true"
import script from "./MyApprovals.vue?vue&type=script&lang=js"
export * from "./MyApprovals.vue?vue&type=script&lang=js"

import "./MyApprovals.vue?vue&type=style&index=0&id=7f8b1855&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8b1855"]])

export default __exports__